import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { StyledContainer } from "./container/Container";
import { GridContext, useBreakpoints } from "./grid-context";
import { GridRow } from "./row/Row";
import { GridCol } from "./col/Col";
const GridComponent = forwardRef((props, ref) => {
    const { breakpoints, ...rest } = props;
    const container = _jsx(StyledContainer, { ref: ref, "data-testid": "Grid", ...rest });
    const themeBreakpoints = useBreakpoints(breakpoints);
    return _jsx(GridContext.Provider, { value: themeBreakpoints, children: container });
});
GridComponent.displayName = "Grid";
export const Grid = Object.assign(GridComponent, {
    Row: GridRow,
    Col: GridCol
});
